import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { Link } from "react-router-dom";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';


// @mui/icons-material
import Visibility from "@mui/icons-material/Visibility";

// core components
import Grid from "@mui/material/Grid";

import Button from "../components/Button.jsx";
import OthelloTitulo from "../componentsothello/OthelloTitulo.jsx";

import {  ResultadoPagoReserva } from "../othelloConstantes.jsx";

export default function ReservaFinPasarela({ ...props }) {
    const { literal, idRol, tipooficina, loginmodoreserva, loginapps, idUser } = props;

    //Ejmplo de obtener un parametro de la URL        
    //ID={Id_Oficina}&dt={Resultado.ID_Reserva}.1

    const navigate = useNavigate();

    const { search } = useLocation();

    const location = useLocation();

    const [loading, setLoading] = React.useState(true);

    const [id, setid] = React.useState(-1);
    const [data, setdata] = React.useState(null);
    const [sign, setsign] = React.useState(null);
    const [ampliacion, setampliacion] = React.useState(false);
    const [desdeticketreserva, setdesdeticketreserva] = React.useState(false);
    const [requestID, setrequestID] = React.useState(null);
    const [resultadopago, setresultadopago] = React.useState(null);

    const [modoExterno, setModoExterno] = React.useState(false);    


    React.useEffect(() => {

        let url = search;
        let params = new URLSearchParams(url);

        let id = params.get('ID');
        let dt = params.get('dt');
        let sign = params.get('sign');
        let ampliacion = params.get('amp');
        let desdersv = params.get('tr'); 
        let esamplia = ampliacion == "1" ? true : false;
        let desdeticket = desdersv == "1" ? true : false;   

        const requestIDPaytef = params.get('requestID') || null;        

        setid(id);
        setdata(dt);
        setsign(sign);
        setampliacion(esamplia);    
        setdesdeticketreserva(desdeticket);
        setrequestID(requestIDPaytef)

        let externo = false;

        if (location.pathname.includes("ticket/finreserva")) {
            externo = true;
            setModoExterno(true);
        }

        getDataPage(id, dt, sign, externo, esamplia, desdeticket, requestIDPaytef);
    }, [loading]);


    //METODOS GLOBALES DE LA PAGINA

    const getDataPage = (id, data, sign, externo, esamplia, desdeticket, requestIDPaytef) => {

        if (id != null && data != null && sign != null)
        {
            var jsonData = JSON.stringify({ id: id, data: data, sign: sign, ampliacion: esamplia, desdeticket: desdeticket, requestid: requestIDPaytef });

            fetch('api/Data/ConfirmarDenegarPagoReserva', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                
                if (res != null) {
                    setLoading(false);
                    setresultadopago(res);
                }
                else if (desdeticket && externo)
                    navigate('/ticket/reserva');
                else if (externo)
                    navigate('/ticket/booking');
                else
                    navigate('/admin/profile');
                
                //this.props.history.push('/admin/profile');                               

            }).catch(error => {
                if (externo)
                    navigate('/ticket/booking');
                else
                    navigate('/admin/profile');
                //this.props.history.push('/admin/profile');               
            });
        }
        else if (ampliacion && externo)
            navigate('/ticket/reserva');
        else if (externo)
            navigate('/ticket/booking');
        else
            navigate('/admin/profile');
        //this.props.history.push('/admin/profile');

    }

    function renderResultadoPago(resultado) {

        if (resultado != null)
        {
            let externo = location != null && location.pathname.includes("ticket/finreserva");

            let pagoOk = resultado.resultadoPago == ResultadoPagoReserva.OK;
            let pagoDesconocidoResultado = resultado.resultadoPago == ResultadoPagoReserva.Desonocido;

            let titulo = pagoOk ? "Operación realizada con exito" : "Operación no completada ";

            if (pagoDesconocidoResultado)
                titulo = "Operacion sin confirmacion, NO Confirmada"

            let linfinal = "/admin/profile";

            if (desdeticketreserva && externo)
            {
                if (resultado.urlticket != null && resultado.urlticket != "")
                    linfinal = resultado.urlticket;
                else
                    linfinal = "/ticket/booking";
            }
            else if (externo)
                linfinal = "/ticket/booking";


            return <Grid item xs={12}>
                <OthelloTitulo titulo={titulo} backgroundColor={pagoOk ? "green" : "red"} />
                {pagoOk ?
                    <p style={{ fontSize: 16, marginTop: 10, marginLeft: 6 }}>El proceso de pago de la operación se ha completado correctamente.<br /><br />

                        Si tiene cualquier duda o consulta, póngase en contacto con nosotros.<br /><br />

                        Muchas gracias.<br /><br />
                    </p> :
                    (pagoDesconocidoResultado ?
                        <p style={{ fontSize: 16, marginTop: 10, marginLeft: 6 }}>
                            El proceso de pago de la operación <strong>NO PUEDE SER CONFIRMADO</strong> en este momento.<br /><br />

                            Actualmente no podemos determinar si la operación se ha completado correctamente. Es posible que el pago se haya realizado, pero no hemos recibido la confirmación correspondiente.<br /><br />

                            Por favor, revise si ha recibido algún cargo en su entidad bancaria. En caso de duda, póngase en contacto con nuestro servicio de atención al cliente para verificar el estado de su operación.<br /><br />

                            Muchas gracias.<br /><br />
                            Código de seguimiento - {requestID}<br /><br />
                        </p>
                    :
                    <p style={{ fontSize: 16, marginTop: 10, marginLeft: 6 }}>
                        El proceso de pago de la operación <strong>NO</strong> se ha completado correctamente.<br /><br />

                        Si ha tenido algun problema durante el proceso vuelta a intertarlo mas tarde o  ante cualquier duda o consulta póngase en contacto con nosotros.<br /><br />

                        Muchas gracias.<br /><br />
                        Codigo Error - {resultado.resultadoPago}<br /><br />
                        </p>
                    )
                }
                {linfinal.startsWith("http") ? (
                    <Button color="facebook" component="a" href={linfinal} target="_self">
                        Volver
                    </Button>
                ) : (
                    <Button color="facebook" component={Link} to={linfinal}>
                        Volver
                    </Button>
                )}
            </Grid>;
        }
        else
            return "Cargando";
    }


    let resultado = loading ? <p><CircularProgress color="secondary" /></p> : renderResultadoPago(resultadopago);

    return (
        <Grid container p={2}>
            {resultado}
        </Grid>
    );
}

